// Module initialisation shared between all client and server bundles

import "./react-16-patch";

import "moment/locale/en-gb";

import { ArmstrongConfig } from "armstrong-react";
ArmstrongConfig.setLocale("en-GB");
